<span [hidden]="!loading"> <ab-spinner-inline></ab-spinner-inline></span>
<div class="integration-error" *ngIf="error">
  <b>{{ error.error }}:&nbsp;</b>{{ error.errorMessage }}.<br /><a
    href="/projects/{{ notice.projectId }}/services/14"
    target="_self"
    >Check your settings</a
  >
</div>
<button
  class="btn btn-holder"
  *ngIf="!card?.url && !error && !loading"
  (click)="createCard()"
  [disabled]="creatingCard"
  type="button"
>
  <span *ngIf="!creatingCard"
    ><i
      class="glyphicon glyphicon-ab-integrations-trello glyphicon--valign-baseline"
    ></i
    >&nbsp; Create Trello card</span
  ><span [hidden]="!creatingCard">
    <ab-spinner-inline></ab-spinner-inline>Creating Trello card</span
  >
</button>
<div *ngIf="card?.url">
  <i
    class="glyphicon glyphicon-ab-integrations-trello glyphicon--valign-baseline"
  ></i
  >&nbsp;<ab-external-link *ngIf="card.url" href="{{ card.url }}"
    >View on Trello</ab-external-link
  >&nbsp;
  <button
    class="btn btn-holder btn--reduced-padding"
    *ngIf="card.url && !error"
    (click)="removeCard()"
    [disabled]="removingCard"
    type="button"
  >
    <span *ngIf="!removingCard">Remove</span
    ><span [hidden]="!removingCard">
      <ab-spinner-inline></ab-spinner-inline>Removing</span
    >
  </button>
</div>
